<template>
    <cms-component v-if="glyph" v-bind="$props" :link="component.link" :style="containerStyle" :class="{'standalone': component.standalone}">
        <i class="glyph-component fa-fw" :class="[fontAwesomePrefix, glyph]" :style="glyphStyle"/>
    </cms-component>
</template>

<script>
import CmsComponent from "@/components/editor/rendering/components/cms-component.vue";
import CmsComponentBackground from "@/helpers/cms/CmsComponentBackground.js";

// cms-component-glyph #hot-reload-debug
export default {
    name: `cms-component-glyph`,
    extends: CmsComponent,
    components: {CmsComponent},
    computed: {
        glyph() {
            let glyph = this.component.glyph;
            if (this.useBinding && this.component.glyphField) {
                glyph = this.boundItem.getField(this.component.glyphField);
            }
            return glyph;
        },
        containerStyle() {
            let style = {
                borderRadius: this.component.mediaProxy.background.radius
            };

            if (!this.component.standalone) {
                style[`--glyph-spacing`] = `${this.component.mediaProxy.spacing}`;
            }
            if (this.component.background.isVisible()) {
                switch (this.component.background.type) {
                    case CmsComponentBackground.BACKGROUNDS.COLOR:
                        style.background = this.cmsWebsite.getColor(this.component.background.color);
                        break;
                    case CmsComponentBackground.BACKGROUNDS.IMAGE:
                        style.background = `url("${this.component.background.image}") no-repeat center center`;
                        style.backgroundSize = `cover`;
                        break;
                }
            }
            return style;
        },
        glyphStyle() {
            let style = {
                color: this.component.mediaProxy.color,
                "--glyph-size": `${this.component.mediaProxy.size}px`
            };

            return style;
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-component-glyph {
    --glyph-size: 32px;
    --glyph-spacing: 0;
    color: var(--scheme-paragraph-color);
    padding: var(--glyph-spacing);

    .glyph-component {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: var(--glyph-size);
        aspect-ratio: 1;
    }

    &.standalone {
        .glyph-component {
            line-height: var(--fa-width, 1.25em);
        }
    }
}
</style>
